import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { initMonitoring } from "./lib/monitoring";
import { installTrackeventsSuppressor } from "./lib/suppressTrackevents";
import { applyDefaultThemeIfUnset } from "./lib/theme";

installTrackeventsSuppressor();
initMonitoring();
// Theme is applied synchronously by an inline script in index.html to prevent FOUC.
// Here we just refresh the cached global default in the background.
void applyDefaultThemeIfUnset();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </ErrorBoundary>
);


